import { download } from '@/utils/utils'
import i18n from '@/locales'

export default {
  created () {
    this.singleActions = [
      {
        label: i18n.t('scope.text_801'),
        action: obj => {
          download(obj.license_content, `${obj.service_type}.${this.$moment(obj.expire).format('YYYY-MM-DD')}.lic`)
        },
        meta: obj => {
          const ret = { validate: true }
          if (this.$moment().isAfter(obj.expire)) {
            ret.validate = false
            ret.tooltip = this.$t('scope.license_expired')
            return ret
          }
          if (obj.cancelled) {
            ret.validate = false
            ret.tooltip = this.$t('scope.license_cancelled')
          }
          return ret
        },
      },
      {
        label: i18n.t('dialog.cancel'),
        action: obj => {
          this.createDialog('CancelLicenseDialog', {
            data: [obj],
            onManager: this.onManager,
            columns: this.columns,
          })
        },
        meta: obj => {
          const ret = { validate: true }
          if (this.$moment().isAfter(obj.expire)) {
            ret.validate = false
            ret.tooltip = this.$t('scope.license_expired')
            return ret
          }
          if (obj.cancelled) {
            ret.validate = false
            ret.tooltip = this.$t('scope.license_cancelled')
          }
          return ret
        },
      },
      {
        label: i18n.t('scope.clone'),
        action: obj => {
          const params = {
            isClone: true,
            data: obj,
            title: this.$t('scope.text_781'),
            onManager: this.onManager,
          }
          if (this.getParams && this.getParams.customer_id) {
            params.customer_id = this.getParams.customer_id
          }
          this.createDialog('ApplyLicenseDialog', params)
        },
      },
    ]
  },
}
